import { handleApiResponse } from '@/functions';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IAccountingSummary } from '@/interfaces';

export const useRequestGetAccountingSummary = (params?: { periodFrom?: string; periodTo?: string }) => {
	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.accountingSummary, params],
		queryFn: ({ queryKey: [_url, _params] }) => {
			const { periodFrom, periodTo } = (_params as typeof params) ?? {};
			const apiParams: Record<string, string> = {};
			if (periodFrom) apiParams['from'] = periodFrom;
			if (periodTo) apiParams['to'] = periodTo;

			return apiClient
				.get<IAccountingSummary>(_url as string, apiParams)
				.then(handleApiResponse);
		}
	});

	return {
		summary: data as IAccountingSummary | undefined,
		isLoading: isFetching,
		error
	};
};
